import {
    URLAPI,
    ACTIVITIES_PATH,
    FILES_ACTIVITIES_PATH,
    ACTIVITIES_USER_TEAMS_PATH,
    ACTIVITIES_USER_PATH,
    ACTIVITY_CREATE_PATH,
    ACTIVITY_UPDATE_PATH,
    ACTIVITY_ITEM_PATH,
    ACTIVITY_CONFIRM_PATH,
    ACTIVITY_LOG_CREATE_PATH,
    MONTHLY_MONITORING_PATH,
    PROCESS_MONTHLY_MONITORING_PATH,
    RESULTS_QUERY_PATH,
    RESULTS_QUERY_ZONE_PATH,
    PROCESS_RESULT_QUERY_PATH,
    DOWNLOAD_RESULT_QUERY_PATH,
    EXCEL_RESULT_QUERY_PATH,
    MATRIX_REPORT_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_activities: {
        data: [],
        status: 0,
        message: {},
    },
    _create_activity: {
        data: {},
        status: 0,
        message: {},
    },
    _create_activity_log: {
        data: {},
        status: 0,
        message: {},
    },
    _confirm_activity: {
        data: {},
        status: 0,
        message: {},
    },
    _update_activity: {
        data: {},
        status: 0,
        message: {},
    },
    _get_report: {
        data: {},
        status: 0,
        message: "",
    },
    _get_report_excel: {
        data: {},
        status: 0,
        message: "",
    },
    _get_report_matrix: {
        data: {},
        status: 0,
        message: "",
    },
};

const GET_ALL_ACTIVITIES = "GET_ALL_ACTIVITIES";
export const CREATE_ACTIVITY = "CREATE_ACTIVITY";
export const CREATE_ACTIVITY_LOG = "CREATE_ACTIVITY_LOG";
export const CONFIRM_ACTIVITY = "CONFIRM_ACTIVITY";
export const UPDATE_ACTIVITY = "UPDATE_ACTIVITY";
export const GET_REPORT = "GET_REPORT";
export const GET_REPORT_EXCEL = "GET_REPORT_EXCEL";
export const GET_REPORT_MATRIX = "GET_REPORT_MATRIX";

export const activities_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_ACTIVITIES:
            return {
                ...state,
                _get_all_activities: action.payload,
            };
        case CREATE_ACTIVITY:
            return {
                ...state,
                _create_activity: action.payload,
            };
        case CREATE_ACTIVITY_LOG:
            return {
                ...state,
                _create_activity_log: action.payload,
            };
        case CONFIRM_ACTIVITY:
            return {
                ...state,
                _confirm_activity: action.payload,
            };
        case UPDATE_ACTIVITY:
            return {
                ...state,
                _update_activity: action.payload,
            };
        case GET_REPORT:
            return {
            ...state,
            _get_report: action.payload,
            };
        case GET_REPORT_EXCEL:
            return {
            ...state,
            _get_report_excel: action.payload,
            };
        case GET_REPORT_MATRIX:
            return {
            ...state,
            _get_report_matrix: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllActivities = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${ACTIVITIES_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_ACTIVITIES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_ACTIVITIES,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_ACTIVITIES,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createActivity = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${ACTIVITY_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateActivity = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${ACTIVITY_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const confirmActivity = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${ACTIVITY_CONFIRM_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CONFIRM_ACTIVITY,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CONFIRM_ACTIVITY,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CONFIRM_ACTIVITY,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createActivityLog = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${ACTIVITY_LOG_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_ACTIVITY_LOG,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_ACTIVITY_LOG,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_ACTIVITY_LOG,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const get_report = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${DOWNLOAD_RESULT_QUERY_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: GET_REPORT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (e) {
      dispatch({
        type: GET_REPORT,
        payload: {
          data: {},
          status: 500,
          message: "Ocurrio un error al generar el reporte",
        },
      });
    }
};

export const get_report_excel = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${EXCEL_RESULT_QUERY_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: GET_REPORT_EXCEL,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (e) {
      dispatch({
        type: GET_REPORT_EXCEL,
        payload: {
          data: {},
          status: 500,
          message: "Ocurrio un error al generar el reporte",
        },
      });
    }
};

export const get_report_matrix = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${MATRIX_REPORT_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: GET_REPORT_MATRIX,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (e) {
      dispatch({
        type: GET_REPORT_MATRIX,
        payload: {
          data: {},
          status: 500,
          message: "Ocurrio un error al generar el reporte",
        },
      });
    }
};

export const searchActivities = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${ACTIVITIES_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchFilesActivities = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${FILES_ACTIVITIES_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}
export const searchActivitiesUser = async (token) => {
    return await axios.get(`${URLAPI}${ACTIVITIES_USER_PATH}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchUserTeamsActivity = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${ACTIVITIES_USER_TEAMS_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchActivityItem = async (token, id) => {
    return await axios.get(`${URLAPI}${ACTIVITY_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchMonthlyMonitoring = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${MONTHLY_MONITORING_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchProcessMonthlyMonitoring = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${PROCESS_MONTHLY_MONITORING_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchResultsQuery = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${RESULTS_QUERY_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchResultsQueryZone = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${RESULTS_QUERY_ZONE_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const searchProcessResultQuery = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${PROCESS_RESULT_QUERY_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const clear_activity = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
